import { H3, StyledAlert } from "App/global-style";
import {
  TrailerProductPriceFormValues,
  TrailerTexts,
} from "../trailerInterface";

import { CoverageComparison } from "Components/CoverageComparison";
import { CurrentPriceMessage } from "Components/CurrentPriceMessage/CurrentPriceMessage";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { CoverageCard } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/CoverageCard";
import { SystemErrorAlert } from "Components/Form/Alert/SystemErrorAlert";
import { getCollectionOfDittoComponents } from "Components/TextContext";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { useCoveragePriceCalculations } from "Store/priceCalculation/priceCalculationHooks";
import { ReduxState } from "Store/rootReducer";
import { TextLanguage } from "Store/texts/interfaces";
import { useFormikContext } from "formik";
import React from "react";
import { useSelector } from "react-redux";

interface Props {
  readonly texts: TrailerTexts;
  readonly lang: TextLanguage;
}

const DEFAULT_DEDUCTIBLE = "1000";

const { trailer: coverageCardTextComponents } = getCollectionOfDittoComponents(
  TextComponentNameLevel1.COVERAGE_CARD,
);

export const TrailerCoverages = (props: Props): React.ReactElement => {
  const formState = useFormikContext<TrailerProductPriceFormValues>();
  const { texts, lang } = props;
  const { isLoading } = useSelector(
    (state: ReduxState) => state.priceCalculation.priceCalculationResult,
  );

  const coverages = useCoveragePriceCalculations();

  if (coverages.length === 0) {
    return <SystemErrorAlert alertId="no-coverages" />;
  }

  return (
    <>
      <StyledAlert
        type="info"
        title={texts.tile.productPrice.deductibleInfo.title[lang]}
        description={texts.tile.productPrice.deductibleInfo.description[lang]}
        fluid
      />
      <H3>{texts.formText.checkPrice.coverage.label[lang]}</H3>
      {coverages.map(([insurance, coverage]) => (
        <CoverageCard
          key={`coverage-card_${insurance}`}
          fieldName="coverage"
          product={ProductBackendName.TRAILER}
          coverage={insurance}
          textComponents={coverageCardTextComponents}
          prices={coverage.prices}
          priceIsLoading={isLoading}
        />
      ))}

      <CoverageComparison
        productBackendName={ProductBackendName.TRAILER}
        selectedCoverage={formState.values.coverage}
      />

      <CurrentPriceMessage
        productBackendName={ProductBackendName.TRAILER}
        coverages={coverages}
        selectedPrices={[
          {
            selectedCoverage: formState.values.coverage,
            selectedDeductible: undefined,
            defaultDeductible: DEFAULT_DEDUCTIBLE,
          },
        ]}
      />
    </>
  );
};
